import { useState } from 'react';
import {
  RiBroadcastLine,
  RiCalculatorLine,
  RiFileExcel2Line,
} from 'react-icons/ri';

import { ButtonComponent } from '../../../components/ButtonComponen';
import { CalendarComponent } from '../../../components/CalendarComponent';
import { InputComponent } from '../../../components/InputComponent';
import { MultiSelectComponent } from '../../../components/MultiSelectComponent';
import { IInventoryProvider } from '../../../interfaces/service/InventoryServiceManagerInterface';
import {
  getSelectedItemsLabel,
  validatePermissions,
} from '../../../utils/utils';
import { PermitsList } from './../../../permitsList';
import { ContainerItem } from '../../../components';
import {
  columnsInFilterInventory,
  columnsTableInventory,
  columnsTableInventoryFilter,
} from './table/helper';

interface IFiltersComponent {
  serviceInventory: IInventoryProvider;
}

export const Filters = (props: IFiltersComponent) => {
  const { serviceInventory } = props;

  const [fromDateInput, setFromDateInput] = useState<any>();
  const [toDateInput, setToDateInput] = useState<any>();

  const extraColumns = columnsInFilterInventory(serviceInventory);

  const dualTextTemplate = (option: any) => {
    return (
      <div>
        <span className="text-grey">({option.code}) </span>
        <span>{option.name}</span>
      </div>
    );
  };

  const renderSelectDevices = () => {
    return (
      <ContainerItem>
        <MultiSelectComponent
          options={serviceInventory.deviceList}
          optionLabel={'name'}
          placeholder="Dispositivos"
          value={serviceInventory.devicesSelected}
          className="h-8"
          onChange={serviceInventory.selectDevice}
          max={0}
          selectedItemsLabel={getSelectedItemsLabel(
            serviceInventory.devicesSelected,
            'dispositivo',
            'dispositivos'
          )}
        />
      </ContainerItem>
    );
  };

  const renderSelectOperators = () => {
    return (
      <ContainerItem>
        <MultiSelectComponent
          options={serviceInventory.operatorsList}
          optionLabel={'name'}
          placeholder="Operadores tecnológicos"
          value={serviceInventory.operatorsSelected}
          className="h-8"
          onChange={serviceInventory.selectOperators}
          max={2}
          selectedItemsLabel={getSelectedItemsLabel(
            serviceInventory.operatorsSelected,
            'operador tecnológicos',
            'operadores tecnológicos'
          )}
        />
      </ContainerItem>
    );
  };

  const renderSelectProjects = () => {
    return (
      <ContainerItem>
        <MultiSelectComponent
          options={serviceInventory.projectsList}
          optionLabel={'name'}
          placeholder="Proyectos"
          value={serviceInventory.projectsSelected}
          className="h-8"
          onChange={serviceInventory.selectProjects}
          max={2}
          selectedItemsLabel={getSelectedItemsLabel(
            serviceInventory.projectsSelected,
            'proyecto',
            'proyectos'
          )}
        />
      </ContainerItem>
    );
  };

  const renderSelectSamTypes = () => {
    return (
      <ContainerItem>
        <MultiSelectComponent
          options={serviceInventory.samTypeList}
          optionLabel={'name'}
          placeholder="Tipos de SAM"
          value={serviceInventory.samTypeSelected}
          className="h-8"
          onChange={serviceInventory.selectSamType}
          max={2}
          itemTemplate={dualTextTemplate}
          selectedItemsLabel={getSelectedItemsLabel(
            serviceInventory.samTypeSelected,
            'tipo de SAM',
            'tipos de SAM'
          )}
        />
      </ContainerItem>
    );
  };

  const renderFindSearch = () => {
    return (
      <ContainerItem>
        <InputComponent
          type={'text'}
          name={'find'}
          className={'h-8'}
          value={serviceInventory.samIdField}
          onChange={serviceInventory.handleFindSearch}
          placeholder="SAM ID"
          classSpan={'p-input-icon-right'}
        />
      </ContainerItem>
    );
  };

  const renderFindSearchDeviceId = () => {
    return (
      <ContainerItem>
        <InputComponent
          type={'text'}
          name={'find'}
          className={'h-8'}
          value={serviceInventory.deviceIdField}
          onChange={serviceInventory.handeFindSearchDeviceId}
          placeholder="Id de equipo"
          classSpan={'p-input-icon-right'}
        />
      </ContainerItem>
    );
  };

  const renderSelectColumn = () => {
    return (
      <ContainerItem>
        <MultiSelectComponent
          options={columnsTableInventoryFilter}
          optionLabel={'header'}
          placeholder="Columnas"
          value={serviceInventory.columnsSelected}
          className=" h-8"
          onChange={(e: any) => {
            serviceInventory.handleSelectColumn(e);
          }}
          selectedItemsLabel={'Columnas'}
        />
      </ContainerItem>
    );
  };

  const renderExcel = () => {
    return validatePermissions(PermitsList.SAM_INVENTORY_EXPORT) ? (
      <div className="flex h-12 w-[15%] text-[50px] text-alternative_green content-center items-center cursor-pointer">
        <RiFileExcel2Line
          onClick={serviceInventory.generateExcel}
          title="Exportar a Excel"
        />
      </div>
    ) : (
      <></>
    );
  };

  const renderCountersRecharge = () => {
    let firstSamTypeId: any = undefined;
    if (
      serviceInventory.selectedSam !== undefined &&
      serviceInventory.selectedSam.length > 0
    ) {
      firstSamTypeId = serviceInventory.selectedSam[0].SamTypeId;
    }
    const allSameSamType = serviceInventory.selectedSam?.every(
      (item: any) => item.SamTypeId === firstSamTypeId
    );
    return (
      <div
        className={`flex h-12 text-[50px] w-[15%] ${
          serviceInventory.selectedSam !== undefined &&
          serviceInventory.selectedSam.length > 0 &&
          allSameSamType
            ? 'text-alternative_green cursor-pointer'
            : 'text-grey cursor-default'
        }`}>
        <RiCalculatorLine
          onClick={() =>
            serviceInventory.selectedSam &&
            serviceInventory.selectedSam.length > 0 &&
            serviceInventory.openRechargesCounterModal()
          }
          title="Agregar contadores"
        />
      </div>
    );
  };

  const renderLimitTriggersComunication = () => {
    return (
      <div
        className={`flex h-12 text-[50px] w-[15%] ${
          serviceInventory.selectedSam !== undefined &&
          serviceInventory.selectedSam.length > 0
            ? 'text-alternative_green cursor-pointer'
            : 'text-grey cursor-default'
        }`}>
        <RiBroadcastLine
          title={'Captura de limites comunicación'}
          onClick={() =>
            serviceInventory.selectedSam &&
            serviceInventory.selectedSam.length > 0 &&
            serviceInventory.openTriggerComunicationModal()
          }
        />
      </div>
    );
  };

  const renderButtonSendData = () => {
    return (
      <ContainerItem className=" col-span-2 items-center justify-end content-end ">
        <ButtonComponent
          label="Enviar"
          onClick={serviceInventory.sendData}
          className={'h-8 w-52'}
        />
      </ContainerItem>
    );
  };

  const renderFromDate = () => {
    return (
      <ContainerItem>
        <CalendarComponent
          name={'fromDate'}
          onChange={(e: any) => {
            setFromDateInput(e.value);
            if (e.value !== undefined && e.value !== null) {
              var dateFrom = new Date(e.value);
              const day = String(dateFrom.getDate()).padStart(2, '0');
              const month = String(dateFrom.getMonth() + 1).padStart(2, '0'); // Los meses empiezan desde 0
              const year = dateFrom.getFullYear();

              const formattedDate = `${year}-${month}-${day}`;
              serviceInventory.setFromDateField(formattedDate);
            } else {
              serviceInventory.setFromDateField('');
            }
          }}
          value={fromDateInput}
          placeholder="Fecha inicio"
          className=" h-8"
        />
      </ContainerItem>
    );
  };

  const renderToDate = () => {
    return (
      <ContainerItem>
        <CalendarComponent
          name={'toDate'}
          onChange={(e: any) => {
            setToDateInput(e.value);
            if (e.value !== undefined && e.value !== null) {
              var dateFrom = new Date(e.value);
              const day = String(dateFrom.getDate()).padStart(2, '0');
              const month = String(dateFrom.getMonth() + 1).padStart(2, '0'); // Los meses empiezan desde 0
              const year = dateFrom.getFullYear();

              const formattedDate = `${year}-${month}-${day}`;
              serviceInventory.setToDateField(formattedDate);
            } else {
              serviceInventory.setToDateField('');
            }
          }}
          value={toDateInput}
          placeholder="Fecha fin"
          className=" h-8"
        />
      </ContainerItem>
    );
  };

  return (
    <div className="flex w-full h-full relative flex-row bg-white rounded-b-lg shadow-lg">
      <div className="grid grid-cols-6 grid-rows-2  w-full">
        {renderFromDate()}
        {renderToDate()}
        {renderSelectDevices()}
        {renderSelectOperators()}
        <ContainerItem className="  items-center justify-end content-end ">
          <>
            {renderLimitTriggersComunication()}
            {renderCountersRecharge()}
            {renderExcel()}
          </>
        </ContainerItem>

        {renderSelectColumn()}
        {renderSelectProjects()}
        {renderSelectSamTypes()}
        {renderFindSearch()}
        {renderFindSearchDeviceId()}
        {renderButtonSendData()}
      </div>
    </div>
  );
};
